// src/components/event/EventHeader.jsx
import React from 'react'

const EventHeader = ({ annivNumber, isPlaying, onToggleMusic }) => {
    return (
        <header className="pointer-events-none fixed inset-x-0 top-0 z-30 flex justify-center">
            <div className="pointer-events-auto mt-3 flex w-[min(100%,900px)] items-center justify-between rounded-full border border-white/10 bg-black/40 px-4 py-2 text-[0.7rem] text-slate-100 backdrop-blur-xl">
                <div className="flex items-center gap-2">
                    <div className="flex h-7 w-7 items-center justify-center rounded-2xl bg-gradient-to-br from-rose-400/90 via-fuchsia-400/90 to-amber-300/90 shadow-[0_0_16px_rgba(251,113,133,0.7)]">
            <span className="text-[0.65rem] font-semibold text-black">
              {annivNumber}Y
            </span>
                    </div>
                    <div className="leading-tight">
                        <p className="text-[0.65rem] uppercase tracking-[0.18em] text-slate-300">
                            Memory
                        </p>
                        <p className="bg-gradient-to-r from-rose-300 via-pink-300 to-amber-200 bg-clip-text text-[0.7rem] font-medium text-transparent">
                            우리 {annivNumber}년의 기록
                        </p>
                    </div>
                </div>

                <div className="flex items-center gap-3">
                    <button
                        onClick={onToggleMusic}
                        className="flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-[0.7rem] font-medium transition hover:bg-white/20"
                    >
            <span
                className={`flex h-5 w-5 items-center justify-center rounded-full border border-white/30 ${
                    isPlaying
                        ? 'bg-rose-400/80 shadow-[0_0_14px_rgba(248,113,113,0.9)]'
                        : 'bg-black/60'
                }`}
            >
              {isPlaying ? (
                  <span className="flex gap-[2px]">
                  <span className="h-3 w-[2px] animate-pulse rounded bg-black" />
                  <span className="h-3 w-[2px] animate-pulse rounded bg-black [animation-delay:120ms]" />
                </span>
              ) : (
                  <span className="ml-[1px] border-l-[6px] border-l-white border-y-[4px] border-y-transparent" />
              )}
            </span>
                        <span>{isPlaying ? '음악 일시정지' : '음악 재생'}</span>
                    </button>
                </div>
            </div>
        </header>
    )
}

export default EventHeader
